import React, { createContext, useContext, useEffect, useState } from "react";

const CompareContext = createContext(null);
const KEY = "hac_compare";

export const CompareProvider = ({ children }) => {
  const [slugs, setSlugs] = useState(() => {
    try {
      const raw = typeof window !== "undefined" && window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(KEY, JSON.stringify(slugs));
    }
  }, [slugs]);

  const add = (slug) =>
    setSlugs((s) => (s.includes(slug) || s.length >= 4 ? s : [...s, slug]));
  const remove = (slug) => setSlugs((s) => s.filter((x) => x !== slug));
  const clear = () => setSlugs([]);
  const toggle = (slug) =>
    setSlugs((s) => (s.includes(slug) ? s.filter((x) => x !== slug) : s.length >= 4 ? s : [...s, slug]));

  return (
    <CompareContext.Provider value={{ slugs, add, remove, clear, toggle }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => {
  const ctx = useContext(CompareContext);
  if (!ctx) throw new Error("useCompare must be used inside CompareProvider");
  return ctx;
};
